export const dashboardDefaults = {
    axisY:{
        labelFontSize: 14
    },
    axisX:{
        labelFontSize: 14
    },
}

export const defaultTitleFontSize = 20 ;